module.exports = "https://secnetweb.ksyun.com/KEC/ksc-node-kvm/assets/ionicons.24712f6c47821394fba7942fbb52c3b2.ttf";